export function ImageExpanded({ src, open, onClose }) {
  if (!open) return <></>;

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(5, 16, 22, 0.88)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 16,
      }}
    >
      <button
        onClick={onClose}
        style={{
          position: "absolute",
          top: 14,
          right: 14,
          width: 34,
          height: 34,
          border: "none",
          borderRadius: "50%",
          background: "rgba(255,255,255,0.18)",
          color: "#FFF",
          cursor: "pointer",
          fontSize: 19,
          lineHeight: 1,
        }}
        aria-label="Fechar imagem"
        title="Fechar"
      >
        ×
      </button>

      <img
        src={src}
        alt="Imagem ampliada do conteudo"
        onClick={(event) => event.stopPropagation()}
        style={{
          maxWidth: "95vw",
          maxHeight: "92vh",
          objectFit: "contain",
          borderRadius: 10,
          boxShadow: "0 16px 48px rgba(0,0,0,0.45)",
        }}
      />
    </div>
  );
}
